import { Http } from "app/Http/Http";

export const investmentAdminApi = {
  get: () => {
    return Http.get(`/admin/user/profile?type=GP`);
  },
};
